import {showErrorNotification, showSuccessNotification} from "../../../global/notifications";
import {approvalRefusalReason} from "../prf-approval-validation";
import {confirmReopen} from "../prf-reopen-confirmation";
import {maintenanceUrl} from "../prf-urls";

const autoFillOpportunityInfo = (e) => {
  const data = e.dataItem;
  const pd = $('[name="ProjectDescription"]');
  const sp = $('[name="EstimatedSalePrice"]').data('kendoNumericTextBox');
  const gm = $('[name="EstimatedGrossMargin"]').data('kendoNumericTextBox');
  const at = $('[name="AgreementType"]').data('kendoDropDownList');
  pd.val(data.ScopeDescription);
  sp.value(data.Amount);
  gm.value(data.GMPerc);
  switch(data.AgreementType) {
    case 'Full Maintenance':
      at.value(0);
      break;
    case 'Preventative Maintenance':
      at.value(1);
      break;
  }
};

const autocompletes = () => {
  const project = $('.js-project-opportunities');
  project.kendoAutoComplete({
    placeholder: 'Search opportunities..',
    filter: 'contains',
    dataSource: {
      autoSync: true,
      schema: {
        model: {
          id: 'OpportunityName',
          fields: {
            OpportunityType: {type:'string'},
            AgreementType: {type:'string'},
            OpportunityName: {type:'string'},
            Amount: {type: 'number'},
            GMPerc: {type:'number'},
            BidBond: {type:'number'},
            PerformanceBond: {type:'number'},
            OwnerName: {type:'string'}
          }
        }
      },
      transport: {
        read: {
          type: 'get',
          url: '/Sales/PursuitRequestForm/MaintenanceOpportunities'
        }
      }
    },
    dataTextField: 'OpportunityName',
    select: autoFillOpportunityInfo
  });
};

const hideFields = (e) => {
  const objData = e.sender.element.data();
  const selector = `.${objData.hideClass}`;
  const ddls = $(`select${selector}`);
  const tas = $(`textarea${selector}`);
  ddls.each((index, ddl) => {
    const that = $(ddl).data('kendoDropDownList');
    that.enable(!(e.sender.text() === objData.hideValue));
  });
  tas.prop('disabled', e.sender.text() === objData.hideValue);
};

const dropdowns = () => {
  const selects = $('select.js-dropdown');
  selects.kendoDropDownList();
  const bidding = $('[name="BiddingToClientDocuments"]').data('kendoDropDownList');
  bidding.bind('change', hideFields);
  bidding.trigger('change');
};

const currencies = () => {
  const cf = $('.js-currency');
  cf.css('text-align', 'right');
  cf.kendoNumericTextBox({
    format: 'c0',
    spinners: false
  });
};

const percentages = () => {
  const pf = $('.js-percentage');
  pf.css('text-align', 'right');
  pf.kendoNumericTextBox({
    format: '### \\%',
    spinners: true
  });
};

// Re-requests the page with a GET. jquery.redirect was used here before, which submits a
// synthesised form and so left the page on a POST that a browser refresh would replay.
const reload = (id) => {
  if(id <= 0) return;
  window.location.assign(maintenanceUrl(id));
};

export const approvals = () => {
  // MaintenanceApproval(int id, string role, string pin)
  const $approvalButton = $('[data-role="approval"]');
  $approvalButton.unbind('click');
  $approvalButton.click(function (e) {
    e.preventDefault();
    const that = $(this);
    const id = $('#Id').val();
    const role = that.data('approval-role');
    const pin = $(`#pin_${role}`).val();
    const comment = $('[name="approval_comment"]').val();
    const action = that.data('action');

    // Validate before disabling the buttons, so a refusal leaves the section usable and the
    // approver can add a comment and try again.
    const refusal = approvalRefusalReason(action, comment);
    if (refusal) {
      showErrorNotification(refusal);
      return;
    }

    $approvalButton.prop('disabled', true);
    const data = {
      id,
      role,
      pin,
      comment,
      action
    };
    $.post({
      url: '/Sales/PursuitRequestForm/MaintenanceApproval',
      data,
      success(d) {
        if(!d.success) {
          showErrorNotification(d.reason);
          $approvalButton.prop('disabled', false);
          return;
        }
        showSuccessNotification(d.reason);
        reload(id);
      },
      // Without this a failed request left the buttons greyed out and said nothing at all.
      error() {
        showErrorNotification('The approval could not be saved. Please try again.');
        $approvalButton.prop('disabled', false);
      }
    });
  });
};

export const submitPrf = () => {
  const $submitButton = $('[data-role="submitPrf"]');
  $submitButton.unbind('click');
  $submitButton.click(function (e) {
    e.preventDefault();
    $submitButton.prop('disabled', true);
    const id = $('#Id').val();
    $.post({
      url: '/Sales/PursuitRequestForm/SubmitMaintenance',
      data: { id },
      success(d) {
        if(!d.success) {
          showErrorNotification(d.reason);
          $submitButton.prop('disabled', false);
          return false;
        }
        showSuccessNotification(d.reason);
        reload(id);
      },
      // Without this a failed request left the button greyed out and said nothing at all.
      error() {
        showErrorNotification('The Pursuit Request Form could not be submitted. Please try again.');
        $submitButton.prop('disabled', false);
      }
    });
  });
}

export const removeApprovals = () => {
  const $removeApprovalsButton = $('[data-role="removeAndUnlock"]');
  $removeApprovalsButton.unbind('click');
  $removeApprovalsButton.click(function (e) {
    e.preventDefault();
    confirmReopen(function () {
      $removeApprovalsButton.prop('disabled', true);
      const id = $('#Id').val();
      const data = {
        id
      };
      $.post({
        url: '/Sales/PursuitRequestForm/RemoveAndUnlockMaintenance',
        data,
        success(d) {
          if(!d.success) {
            showErrorNotification(d.reason);
            $removeApprovalsButton.prop('disabled', false);
            return false;
          }
          showSuccessNotification(d.reason);
          reload(id);
        },
        // Without this a failed request left the button greyed out and said nothing at all.
        error() {
          showErrorNotification('The approvals could not be removed. Please try again.');
          $removeApprovalsButton.prop('disabled', false);
        }
      });
    });
  });
}

const validate = () => {
  const required = $('[data-required="true"]');
  required.removeClass('fieldValidationError');
  let success = true;
  $.each(required, function (index, ele) {
    const item = $(ele);
    const itemValue = item.val();
    if (!itemValue || itemValue === '' || itemValue === -1) {
      item.parent().addClass('fieldValidationError');
      success = false;
    }
  });
  return success;
};

const saveForm = (e) => {
  e.preventDefault();
  const submitBtn = $('.js-submit');
  submitBtn.prop('disabled', true);
  if(validate()) {
    const data = $('form#maintenanceForm').serializeArray();
    data.push({
      name: 'id',
      value: $('#Id').val()
    });
    $.post({
      url: '/Sales/PursuitRequestForm/SaveMaintenance',
      data,
      success(d) {
        if(!d.success) {
          showErrorNotification(d.reason);
          submitBtn.prop('disabled', false);
          return false;
        }
        showSuccessNotification('Maintenance Pursuit Request Form saved!');
        reload(d.id)
      }
    });
  } else {
    showErrorNotification('Please fill out all required fields.');
    submitBtn.prop('disabled', false);
  }
};

const saveOptions = () => {
  const save = $('.js-submit');
  save.on('click', saveForm);
};

export default function () {
  const form = $('form#maintenanceForm');
  if(form.length === 0) {
    approvals();
    submitPrf();
    removeApprovals();
    return;
  }
  autocompletes();
  dropdowns();
  approvals();
  submitPrf();
  removeApprovals();
  saveOptions();
}